import React, {
  ReactNode,
  createContext,
  useState,
  useEffect,
  useContext,
  SetStateAction,
  Dispatch,
} from 'react';
import { useLocation } from 'react-router-dom';

const TableProgressContext = createContext<[number, Dispatch<SetStateAction<number>>] | undefined>(
  undefined
);

interface State {
  rowIndex: number;
}

const TableProgressProvider = ({ children }: { children: ReactNode }) => {
  const [progress, setProgress] = useState(0);
  const { state } = useLocation<State>();

  useEffect(() => {
    if (state?.rowIndex || state?.rowIndex === 0) {
      setProgress(state?.rowIndex);
    }
  }, [state?.rowIndex]);

  return (
    <TableProgressContext.Provider value={[progress, setProgress]}>
      {children}
    </TableProgressContext.Provider>
  );
};

/**
 * Saves the row index of the last visited dashboard
 */
function useTableProgress() {
  const context = useContext(TableProgressContext);
  if (context === undefined) {
    throw new Error('useTableProgress must be used within a TableProgressProvider');
  }
  return context;
}

export { TableProgressProvider, useTableProgress };
